import React, { useState } from "react";
import { Drawer } from "antd";
import { LuMenu } from "react-icons/lu";
import "./SideDrawer.css";
import { Link } from "react-router-dom";

const SideDrawer = () => {
  const [open, setOpen] = useState(false);
  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };
  return (
    <div className="menu">
      <LuMenu className="menuBtn" onClick={showDrawer} />
      <Drawer
        onClose={onClose}
        open={open}
        onClick={(e) => {
          e.stopPropagation();
          setOpen(false);
        }}
      >
        <ul>
          <li onClick={onClose}>
            <Link to={"/"}>Home</Link>
          </li>
          <li onClick={onClose}>
            <Link to={"/privacyPolicy"}>Privacy Policy</Link>
          </li>
        </ul>
      </Drawer>
    </div>
  );
};
export default SideDrawer;
